import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Badge, Button, IconButton } from '@mui/material';
import { TranslateW } from '../../../Utils/Languages/Translate';

const SCAN_ICON = '/images/qr_code_scanner.svg';

const ScanButton = ({
    onClick,
    label,
    tooltipText,
    disabled,
    size,
    iconSize,
    badgeSx,
    sx,
    ariaLabel,
}) => {
    const tip = tooltipText || TranslateW('ScanFindAssetTooltip');
    const icon = <img src={SCAN_ICON} alt="Scan" width={iconSize} height={iconSize} />;

    const trigger = label != null ? (
        <Button size={size} startIcon={icon} onClick={onClick} disabled={disabled} sx={sx}>
            {label}
        </Button>
    ) : (
        <IconButton aria-label={ariaLabel || tip} size={size} onClick={onClick} disabled={disabled} sx={sx}>
            {icon}
        </IconButton>
    );

    return (
        <Tooltip title={tip}>
            <span>
                <Badge color="primary" badgeContent={TranslateW('ScanNewBadge')} sx={badgeSx}>
                    {trigger}
                </Badge>
            </span>
        </Tooltip>
    );
};

ScanButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string,
    tooltipText: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    iconSize: PropTypes.number,
    badgeSx: PropTypes.object,
    sx: PropTypes.object,
    ariaLabel: PropTypes.string,
};

ScanButton.defaultProps = {
    label: undefined,
    tooltipText: undefined,
    disabled: false,
    size: 'medium',
    iconSize: 14,
    badgeSx: { '& .MuiBadge-badge': { fontSize: '8px', height: 14, minWidth: 14, top: 2 } },
    sx: {},
    ariaLabel: undefined,
};

export default ScanButton;
